"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Calendar = /** @class */ (function () {
    /**
     *
     */
    function Calendar(date) {
        if (!date)
            date = new Date();
        if (typeof date == 'number') {
            var tmp = new Date();
            tmp.setTime(date);
            date = tmp;
        }
        this.m_date = date;
    }
    Calendar.prototype.setTime = function (d) {
        this.m_date = d;
    };
    Calendar.getInstance = function () {
        return new Calendar();
    };
    Calendar.prototype.get = function (Value) {
        switch (Value) {
            case Calendar.DAY_OF_MONTH:
                return this.m_date.getDate();
            case Calendar.MONTH:
                return this.m_date.getMonth() + 1;
            case Calendar.YEAR:
                return this.m_date.getFullYear();
            case Calendar.HOUR_OF_DAY:
                return this.m_date.getHours();
            case Calendar.MINUTE:
                return this.m_date.getMinutes();
            case Calendar.SECOND:
                return this.m_date.getSeconds();
            default:
                return 0;
        }
    };
    Calendar.prototype.getTime = function () {
        return this.m_date;
    };
    Calendar.prototype.toString = function () {
        return this.m_date.toDateString();
    };
    Calendar.ALL_STYLES = 0;
    Calendar.AM = 0;
    Calendar.AM_PM = 9;
    Calendar.APRIL = 3;
    Calendar.AUGUST = 7;
    Calendar.DATE = 5;
    Calendar.DAY_OF_MONTH = 5;
    Calendar.DAY_OF_WEEK = 7;
    Calendar.DAY_OF_WEEK_IN_MONTH = 8;
    Calendar.DAY_OF_YEAR = 6;
    Calendar.DECEMBER = 11;
    Calendar.DST_OFFSET = 16;
    Calendar.ERA = 0;
    Calendar.FEBRUARY = 1;
    Calendar.FIELD_COUNT = 17;
    Calendar.FRIDAY = 6;
    Calendar.HOUR = 10;
    Calendar.HOUR_OF_DAY = 11;
    Calendar.JANUARY = 0;
    Calendar.JULY = 6;
    Calendar.JUNE = 5;
    Calendar.LONG = 2;
    Calendar.LONG_FORMAT = 2;
    Calendar.LONG_STANDALONE = 32770;
    Calendar.MARCH = 2;
    Calendar.MAY = 4;
    Calendar.MILLISECOND = 14;
    Calendar.MINUTE = 12;
    Calendar.MONDAY = 2;
    Calendar.MONTH = 2;
    Calendar.NARROW_FORMAT = 4;
    Calendar.NARROW_STANDALONE = 32772;
    Calendar.NOVEMBER = 10;
    Calendar.OCTOBER = 9;
    Calendar.PM = 1;
    Calendar.SATURDAY = 7;
    Calendar.SECOND = 13;
    Calendar.SEPTEMBER = 8;
    Calendar.SHORT = 1;
    Calendar.SHORT_FORMAT = 1;
    Calendar.SHORT_STANDALONE = 32769;
    Calendar.SUNDAY = 1;
    Calendar.THURSDAY = 5;
    Calendar.TUESDAY = 3;
    Calendar.UNDECIMBER = 12;
    Calendar.WEDNESDAY = 4;
    Calendar.WEEK_OF_MONTH = 4;
    Calendar.WEEK_OF_YEAR = 3;
    Calendar.YEAR = 1;
    Calendar.ZONE_OFFSET = 15;
    return Calendar;
}());
exports.default = Calendar;

//# sourceMappingURL=Calendar.js.map
